import { Avatar, Box, Card, CardContent, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CustomText from 'components/common/CustomText/CustomText';
import { colors } from 'styles/colors';
import defaultAvatar from 'assets/avatar.png';
import { useMarkNotificationAsRead } from 'hooks/useNotifications';
import { useTimeAgo } from 'hooks/useTimeAgo';

interface Props {
  item: any;
  onRead?: () => void;
}

export default function NotificationEntry({ item, onRead }: Props) {
  const navigate = useNavigate();

  const { mutate: markAsRead } = useMarkNotificationAsRead(
    () => onRead?.(),
    () => {},
  );

  const handleClick = () => {
    if (!item.read_flag) {
      markAsRead(item.id);
    }

    if (item.deeplink) {
      navigate(item.deeplink);
    }
  };

  const senderName = item.sender ? `${item.sender.first_name} ${item.sender.last_name}`.trim() : null;
  const timeAgo = useTimeAgo(item.created);

  return (
    <Card
      onClick={handleClick}
      sx={{
        borderRadius: 3,
        boxShadow: '0 8px 24px rgba(0,0,0,0.06)',
        cursor: 'pointer',
        backgroundColor: colors.white,
      }}
    >
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        <Stack direction="row" spacing={1.5} alignItems="flex-start">
          <Avatar
            src={item.sender_media?.href_small ?? defaultAvatar}
            alt={senderName ?? 'MSLogger'}
            sx={{ width: 38, height: 38, bgcolor: colors.avatarBg }}
          />

          <Box flex={1}>
            <CustomText text={item.title} color={colors.primary} fontSize={16} fontWeight={item.read_flag ? 500 : 700} />
            {item.message && (
              <CustomText text={item.message} color={colors.secondary} fontSize={14} />
            )}
            {timeAgo && (
              <CustomText text={timeAgo} color={colors.gray} fontSize={12} sx={{ mt: 0.5 }} />
            )}
          </Box>

          {!item.read_flag && (
            <Box mt={0.5} width={8} height={8} borderRadius="50%" bgcolor={colors.primary} />
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
